module.exports = __webpack_public_path__ + "static/media/0.db9097e8.jpg";